import React from 'react'

export function PiSearchIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.8194 12.6592L17.3334 16.1724L16.1724 17.3333L12.6592 13.8193C11.352 14.8672 9.72612 15.4372 8.05076 15.4348C3.97475 15.4348 0.666687 12.1267 0.666687 8.0507C0.666687 3.97469 3.97475 0.666626 8.05076 0.666626C12.1268 0.666626 15.4348 3.97469 15.4348 8.0507C15.4372 9.72606 14.8673 11.352 13.8194 12.6592ZM12.1735 12.0504C13.2148 10.9796 13.7963 9.54427 13.7939 8.0507C13.7939 4.87719 11.2234 2.30753 8.05076 2.30753C4.87725 2.30753 2.30759 4.87719 2.30759 8.0507C2.30759 11.2234 4.87725 13.7939 8.05076 13.7939C9.54433 13.7962 10.9797 13.2147 12.0505 12.1735L12.1735 12.0504Z" fill="#B6C1D6"/>
    </svg>
  )
}
